<ng-container *ngIf="autocompleteFct; else content">
    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
</ng-container>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>

<ng-template #dropdown>
    <sh-droppanel
        [focusMode]="focusIndex >= 0"
        [inOverflownContainer]="inOverflownContainer"
        [clearMarginModifiers]="clearMarginModifiers"
        [isOpen$]="isOpen$"
        [hasOptions$]="hasOptions$"
    >
        <div droppanelToggle class="sh-form-multiselect" (shClickOutside)="closeDropdown()">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
        <ul #optionContainer shChildIndex class="sh-droppanel__list">
            <li *ngIf="loadingMessage && (loading$ | async)">
                <div class="sh-droppanel__list-action sh-no-pointer-events">
                    <ng-container
                        [ngTemplateOutlet]="noCheckbox"
                        [ngTemplateOutletContext]="{ suggestion: { label: loadingMessage }, index: 0 }"
                    ></ng-container>
                </div>
            </li>
            <ng-container *ngIf="suggestions$ | async as suggestions">
                <ng-container *ngIf="!(loadingMessage && (loading$ | async))">
                    <li *ngFor="let suggestion of suggestions.options; let index = index" class="sh-droppanel__list__item">
                        <button
                            tabindex="-1"
                            type="button"
                            class="sh-droppanel__list-action"
                            (click)="onSelect(suggestion)"
                            (mouseenter)="onHover($event)"
                        >
                            <ng-container
                                [ngTemplateOutlet]="multiple ? checkbox : noCheckbox"
                                [ngTemplateOutletContext]="{ suggestion: suggestion, index: index }"
                            >
                            </ng-container>
                        </button>
                    </li>
                    <li *ngIf="noResultsMessage && !(loading$ | async) && suggestions.options.length === 0">
                        <div class="sh-droppanel__list-action sh-no-pointer-events">
                            <ng-container
                                [ngTemplateOutlet]="noCheckbox"
                                [ngTemplateOutletContext]="{ suggestion: { label: noResultsMessage }, index: 0 }"
                            ></ng-container>
                        </div>
                    </li>
                </ng-container>
            </ng-container>
        </ul>
    </sh-droppanel>
</ng-template>

<ng-template #checkbox let-suggestion="suggestion" let-index="index">
    <div class="sh-droppanel__list-action__label">
        <input
            tabindex="-1"
            type="checkbox"
            [id]="suggestion + '-option-' + index"
            class="sh-checkbox sh-droppanel__list-action__checkbox"
            [checked]="suggestion.checked"
            (mouseenter)="onHover($event)"
        />
        <ng-container [ngSwitch]="suggestion.checked">
            <b *ngSwitchCase="true">{{ suggestion.label }}</b>
            <ng-container *ngSwitchDefault>{{ suggestion.label }}</ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #noCheckbox let-suggestion="suggestion">
    <div class="sh-droppanel__list-action__label">{{ suggestion.label }}</div>
</ng-template>
